import LMPErrorMessage from "./LMPErrorMessage";

class LMPErrorResponse {
    status: number;
    statusText: string;
    data: { error: LMPErrorMessage };

    constructor({
        status,
        statusText,
        data,
    }: {
        status: number;
        statusText: string;
        data: { error: LMPErrorMessage };
    }) {
        this.status = status;
        this.statusText = statusText;
        this.data = data;
    }
}

export default LMPErrorResponse;
